export interface SchoolDataResponse {
    id: number;
    name: string;
    domainList: string[];
    subDomain: string;
    logoUrl: string;
    backgroundUrl: string;
    primaryColor: string;
    secondaryColor: string;
    tertiaryColor: string;

    // errors
    code: string;
    message: string;
}

export interface SchoolVerification {
    id: string;
    isVerified: boolean;
    message: string;
    noAcademicEmail: boolean;
    studentEmail: string;
    userId: string;
    schoolId: number;
    school: Omit<SchoolDataResponse, 'logoUrl'> & { logo: string };
    state: SchoolVerificationState;
}

export enum SchoolVerificationState {
    needVerification = 'need_verification',
    ignored = 'ignore',
    pending = 'pending',
    verified = 'verified',

}
